import { HighlightCard } from '@/components/ui/data-display/cards/HighlightCard';
import { HighlightSection } from '@/components/ui/layouts/sections/HighlightSection';
import { highlightBlock } from '@mage-ui/styled-system/recipes';

export const HighlightBlock = ({ data }) => {
  return (
    <HighlightSection
      heading={{
        epi: data?.fields?.epi,
      }}
      className={highlightBlock().root}
    >
      <HighlightCard
        data={{
          title: data?.fields?.title,
          description: data?.fields?.description,
          cta1_description: data?.fields?.cta1_description,
          cta1_text: data?.fields?.cta1_text,
          cta1_slug: data?.fields?.cta1_slug,
          cta2_description: data?.fields?.cta2_description,
          cta2_text: data?.fields?.cta2_text,
          cta2_slug: data?.fields?.cta2_slug,
        }}
      />
    </HighlightSection>
  );
};
